import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ProfileTabs = ({ activeTab, onTabChange, postsCount, photosCount, friendsCount }) => {
  const tabs = [
    {
      id: 'posts',
      label: 'Posts',
      icon: 'FileText',
      count: postsCount
    },
    {
      id: 'photos',
      label: 'Photos',
      icon: 'Image',
      count: photosCount
    },
    {
      id: 'friends',
      label: 'Friends',
      icon: 'Users',
      count: friendsCount
    }
  ];

  return (
    <div className="bg-card rounded-lg shadow-elevation-1 p-1">
      <div className="flex space-x-1">
        {tabs?.map((tab) => (
          <button
            key={tab?.id}
            onClick={() => onTabChange(tab?.id)}
            className={`flex-1 flex items-center justify-center space-x-2 px-4 py-3 rounded-md text-sm font-medium transition-all duration-150 ${
              activeTab === tab?.id
                ? 'bg-primary text-primary-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground hover:bg-muted'
            }`}
            aria-current={activeTab === tab?.id ? 'page' : undefined}
          >
            <Icon name={tab?.icon} size={18} />
            <span className="hidden sm:block">{tab?.label}</span>
            <span className={`text-xs px-2 py-0.5 rounded-full ${
              activeTab === tab?.id
                ? 'bg-primary-foreground/20 text-primary-foreground'
                : 'bg-muted text-muted-foreground'
            }`}>
              {tab?.count}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProfileTabs;